import { Space, Tooltip } from 'antd';
import { Surface } from 'components/Surface';
import { useTypeSafeTranslation } from 'hooks';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/router';
import React, { FC, useMemo } from 'react';
import { symbols } from '../datas';
import styles from './Right.module.less';

const Right: FC = () => {
  const { t } = useTypeSafeTranslation();
  const router = useRouter();
  const { id }: any = router.query;

  const data = useMemo(() => {
    return symbols[id];
  }, [id]);

  return (
    <Surface borderLess className={styles.root}>
      <h1 className={styles.title}>
        {id} ({data.name})
      </h1>

      <div className="text-16">
        <p className="primary">{t('symbol_detail.project_basic_info')}</p>
        <p>
          <Trans i18nKey={data.basic} />
        </p>
        <p className="primary">{t('symbol_detail.project_intro')}</p>
        <Trans i18nKey={data.intro} />
      </div>

      <div className={styles.source}>
        <Space size={12}>
          <Tooltip title={data.coingeckoLink}>
            <a href={data.coingeckoLink} target="_blank" rel="noopener noreferrer">
              <img width={42} src="/images/social/coingecko_logo.png" alt={data.coingeckoLink} />
            </a>
          </Tooltip>

          <Tooltip title={data.cmcLink}>
            <a href={data.cmcLink} target="_blank" rel="noopener noreferrer">
              <img style={{ borderRadius: '50%' }} width={42} src="/images/social/cmc_logo.png" alt={data.cmcLink} />
            </a>
          </Tooltip>
        </Space>
      </div>
    </Surface>
  );
};

export default Right;
